export const authTranslations = {
  fr: {
    login: {
      title: "Bienvenue sur Nablow !",
      emailStepTitle: "Bienvenue sur Nablow !",
      emailStepSubtitle: "Prêt à créer quelque chose d'incroyable ?",
      passwordStepTitle: "Ravi de vous revoir !",
      passwordStepSubtitle: "Plus qu'une étape et c'est parti !",
      email: "Adresse e-mail",
      password: "Mot de passe",
      submit: "Se connecter",
      continue: "Continuer",
      back: "Retour",
      rememberMe: "Se souvenir de moi",
      forgotPassword: "Mot de passe oublié ?",
      continueWithGoogle: "Continuer avec Google",
      continueWithApple: "Continuer avec Apple",
      or: "Ou",
    },
    sessionCheck: {
      unavailable: "Impossible de vérifier votre session pour le moment.",
      retry: "Réessayer",
    },
    logout: {
      button: "Se déconnecter",
    },
    menu: {
      profile: "Mon profil",
      settings: "Paramètres",
      logout: "Se déconnecter",
    },
    errors: {
      invalidCredentials: "E-mail ou mot de passe incorrect. Vérifiez votre saisie et réessayez.",
      logoutFailed: "Erreur lors de la déconnexion",
      statusCheckFailed: "Erreur lors de la vérification du statut",
      networkError: "Connexion impossible pour le moment. Vérifiez votre connexion internet et réessayez.",
      unknownError: "Une erreur inconnue est survenue",
      googleLoginFailed: "La connexion avec Google a échoué. Réessayez ou utilisez votre e-mail.",
      socialLoginFailed: "La connexion sociale a échoué",
      registrationClosed: "Les inscriptions sont momentanément fermées. Vous avez déjà un compte ? Connectez-vous.",
    },
    validation: {
      email: {
        required: "Email requis",
        invalid: "Email invalide",
      },
      password: {
        required: "Mot de passe requis",
        minLength: "Le mot de passe doit contenir au moins 8 caractères",
        maxLength: "Le mot de passe ne peut pas dépasser 100 caractères",
      },
    },
  },
} as const;
